import { UseFormReturn, useFieldArray } from 'react-hook-form';

import { Flex } from 'components/layout';
import { IntegrationCore } from 'types/Integration';

import { QuickQuoteInputs, TransportTypeOption } from '../../types';
import { CommoditySection } from './CommoditySection';
import { ItemsSection } from './ItemsSection';
import { QuoteInformationSection } from './QuoteInformationSection';
import { ServiceAndPaymentSection } from './ServiceAndPaymentSection';
import { StopsSection } from './StopsSection';

export interface UnifiedTurvoLTLFormProps {
  formMethods: UseFormReturn<QuickQuoteInputs, any, QuickQuoteInputs>;
  transportTypeOptions: TransportTypeOption[];
  tmsIntegrations?: IntegrationCore[];
}

export function UnifiedTurvoLTLForm({
  formMethods,
  transportTypeOptions,
  tmsIntegrations,
}: UnifiedTurvoLTLFormProps) {
  const itemFieldArray = useFieldArray({
    control: formMethods.control,
    name: 'ltl.items',
    rules: {
      required: 'At least one item is required',
    },
  });

  return (
    <Flex direction='col' gap='lg' className='w-full'>
      <QuoteInformationSection
        formMethods={formMethods}
        transportTypeOptions={transportTypeOptions}
        tmsIntegrations={tmsIntegrations}
      />
      <Flex direction='col' gap='sm' className='w-full'>
        <StopsSection formMethods={formMethods} />
        <CommoditySection
          formMethods={formMethods}
          replaceItems={itemFieldArray.replace}
        />
      </Flex>
      <ItemsSection formMethods={formMethods} itemFieldArray={itemFieldArray} />
      <ServiceAndPaymentSection formMethods={formMethods} />
    </Flex>
  );
}
